export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-store-line', imageSeq: 'cat-shoes-2026' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', icon: 'ri-shirt-line', imageSeq: 'cat-hoodies-2026' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', icon: 'ri-t-shirt-line', imageSeq: 'cat-tshirts-2026' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', icon: 'ri-shirt-line', imageSeq: 'cat-jackets-2026' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', icon: 'ri-store-line', imageSeq: 'cat-pants-2026' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', icon: 'ri-shield-user-line', imageSeq: 'cat-headwear-2026' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', icon: 'ri-stack-line', imageSeq: 'cat-sets-2026' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', icon: 'ri-checkbox-blank-line', imageSeq: 'cat-underwear-2026' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', icon: 'ri-shirt-line', imageSeq: 'cat-jersey-2026' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', icon: 'ri-glasses-line', imageSeq: 'cat-accessories-2026' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', icon: 'ri-handbag-line', imageSeq: 'cat-bags-2026' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html', icon: 'ri-bring-forward', imageSeq: 'cat-belts-2026' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html', icon: 'ri-contrast-drop-line', imageSeq: 'cat-perfumes-2026' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html', icon: 'ri-more-line', imageSeq: 'cat-other-2026' },
];

export const featuredCategories = [
  {
    name: 'Shoes',
    description: 'Latest sneaker finds and footwear collections from Sugargoo spreadsheets',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'feat-shoes-2026',
    size: 'large',
  },
  {
    name: 'Hoodies & Sweaters',
    description: 'Trending streetwear hoodies and sweaters at competitive prices',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageSeq: 'feat-hoodies-2026',
    size: 'medium',
  },
  {
    name: 'T-Shirts & Jackets',
    description: 'Essential tops and outerwear from verified Sugargoo lists',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageSeq: 'feat-tshirts-2026',
    size: 'medium',
  },
];